import { Button, Typography } from "@mui/material";
import { IconImage } from "@/components";
import { delete_img, unlock_right } from "@/constants";
import { formatDateOrTime } from "@/utils";
import { StyledContainedButton, StyledContainer } from "./styles";
import { IoMdClose } from "react-icons/io";

export const clientColumns = ({
  handleTriggerModal,
  isSuperAdmin = false,
}: {
  handleTriggerModal: (
    item: Client,
    type: "delete" | "restrict" | "unblock"
  ) => void;
  isSuperAdmin?: boolean;
}): IColumn<Client>[] => [
  {
    name: "Client Name",
    key: "firstName",
    align: "left",
    width: "148px",
  },
  {
    name: "Email",
    key: "email",
    align: "left",
    width: "428px",
  },
  {
    name: "Date Added",
    key: "createdAt",
    align: "left",
    width: "148px",
    component: (item) => (
      <>
        <Typography variant="body2" color={"#030712"}>
          {formatDateOrTime(item.createdAt, "date")}
        </Typography>
        <Typography variant="body1" fontSize={"0.75rem"} color={"#8E9494"}>
          {formatDateOrTime(item.createdAt, "time")}
        </Typography>
      </>
    ),
  },
  ...(isSuperAdmin
    ? ([
        {
          name: "Client ID",
          key: "_id",
          align: "left",
          width: "220px",
        },
      ] as IColumn<Client>[])
    : []),
  {
    name: "Actions",
    key: "actions",
    align: "center",
    width: "433px",
    component: (item) => (
      <StyledContainer gap="10px">
        {!item.isRestricted ? (
          <StyledContainedButton
            startIcon={<IoMdClose />}
            onClick={(event) => {
              event.stopPropagation();
              handleTriggerModal(item, "restrict");
            }}
            sx={{
              color: "rgba(234, 67, 52, 1)",
            }}
            variant="outlined"
            title="Restrict"
          />
        ) : (
          <StyledContainedButton
            startIcon={<IconImage src={unlock_right} size="auto" />}
            variant="outlined"
            onClick={(event) => {
              event.stopPropagation();
              handleTriggerModal(item, "unblock");
            }}
            sx={{
              color: "rgba(52, 168, 83, 1)",
            }}
            title="Unblock"
          />
        )}
        <Button
          variant="outlined"
          onClick={(event) => {
            event.stopPropagation();
            handleTriggerModal(item, "delete");
          }}
          style={{
            color: "#EA4334",
            borderColor: "#E6E7E7",
            fontWeight: 500,
          }}
        >
          <IconImage src={delete_img} size="auto" />
        </Button>
      </StyledContainer>
    ),
  },
];
